export default "__VITE_ASSET__CPKy54Hx__"